import React from "react";
import { motion } from "motion/react";
import { Search, PenTool, Code2, Rocket, ShieldCheck, MessageSquare } from "lucide-react";

const steps = [
  {
    icon: Search,
    title: "Discovery",
    description: "We dive deep into your business goals, target audience, and technical requirements to define the perfect solution.",
    color: "text-violet-400",
    bg: "bg-violet-500/10"
  },
  {
    icon: PenTool,
    title: "Design",
    description: "Creating high-fidelity prototypes and intuitive user interfaces that align with your brand identity.",
    color: "text-fuchsia-400",
    bg: "bg-fuchsia-500/10"
  },
  {
    icon: Code2,
    title: "Development",
    description: "Building your application with clean, scalable code and robust backend logic using modern technologies.",
    color: "text-cyan-400",
    bg: "bg-cyan-500/10"
  },
  {
    icon: ShieldCheck,
    title: "Testing",
    description: "Rigorous quality assurance to ensure your platform is secure, fast, and bug-free across all devices.",
    color: "text-emerald-400",
    bg: "bg-emerald-500/10"
  },
  {
    icon: Rocket,
    title: "Deployment",
    description: "Launching your project with optimized hosting, SSL security, and performance monitoring.",
    color: "text-orange-400",
    bg: "bg-orange-500/10"
  },
  {
    icon: MessageSquare,
    title: "Support",
    description: "Ongoing maintenance and strategic updates to ensure your digital presence continues to grow.",
    color: "text-pink-400",
    bg: "bg-pink-500/10"
  }
];

export function Process() {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12">
      {steps.map((step, index) => (
        <motion.div
          key={step.title}
          initial={{ opacity: 0, x: index % 2 === 0 ? -20 : 20 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: index * 0.1 }}
          className="relative group"
        >
          <div className="flex gap-6">
            <div className={`flex-shrink-0 w-16 h-16 rounded-2xl ${step.bg} border border-white/5 flex items-center justify-center ${step.color} group-hover:scale-110 transition-transform duration-500 shadow-xl`}>
              <step.icon size={28} />
            </div>
            <div>
              <div className="flex items-center gap-3 mb-3">
                <span className="text-[10px] font-black text-neutral-700">0{index + 1}</span>
                <h3 className="text-xl font-black uppercase tracking-tight text-white group-hover:text-violet-400 transition-colors">{step.title}</h3>
              </div>
              <p className="text-neutral-500 text-sm leading-relaxed font-medium group-hover:text-neutral-400 transition-colors">
                {step.description}
              </p>
            </div>
          </div>
        </motion.div>
      ))}
    </div>
  );
}